import { Clickable } from 'components';
import styled from 'styled-components';

const OuterCircle = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 20px;
  border: 2px solid${(props) => (props.active ? props.activeColor || '#fff' : '#000')};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const InnerCircle = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 20px;
  background-color: #fff;

  ${(props) => !props.active && 'display: none;'};
`;

const Radio = ({ active, activeColor, onClick, disabled }) => (
  <Clickable onClick={onClick} disabled={disabled}>
    <OuterCircle active={active} activeColor={activeColor}>
      <InnerCircle active={active} />
    </OuterCircle>
  </Clickable>
);

export default Radio;
